import styled from 'styled-components';
import { glassEffect } from '../../theme';

export const SettingsCard = styled.div`
  ${glassEffect}
  padding: 25px;
  border-radius: 12px;
  margin-bottom: 30px;
`;

export const CardTitle = styled.h2`
  color: ${({ theme }) => theme.heading};
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 20px;
`;

export const HelperText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.text};
  margin-top: 20px; /* Increased margin */
  text-align: center; /* Center align the text */
`;

// --- NEW STYLE FOR THE LINK ---
export const InlineLink = styled.a`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.primary};
  text-decoration: none; /* Remove default underline */
  font-weight: 600;

  &:hover {
    text-decoration: underline; /* Add underline on hover */
  }
`;